import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, Card, CardContent, Avatar, useTheme, Rating } from '@mui/material';
import { SectionBox } from './sectionBox';
import { SectionHeader } from './sectionHeader';
import { modernizeColors } from '../../theme/modernizeTheme';
// Generate initials from name
const getInitials = (name) => {
    return name
        .split(' ')
        .map(part => part[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
};
// Generate a consistent color based on name
const getAvatarColor = (name) => {
    const colors = [
        modernizeColors.primary.dark, // Primary blue (accessible)
        modernizeColors.secondary.dark, // Secondary cyan (accessible)
        modernizeColors.success.dark, // Success green (accessible)
        modernizeColors.warning.dark, // Warning amber (accessible)
        modernizeColors.error.dark, // Error coral (accessible)
    ];
    const index = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
    return colors[index];
};
export const TestimonialsSection = ({ title, subtitle, testimonials, }) => {
    const theme = useTheme();
    return (_jsx(SectionBox, { background: theme.palette.background.default, py: { xs: 8, md: 20 }, children: _jsxs(Container, { maxWidth: "lg", sx: { px: { xs: 4, md: 6 } }, children: [_jsx(SectionHeader, { title: title, subtitle: subtitle, marginBottom: { xs: 6, md: 12 } }), _jsx(Grid, { container: true, spacing: { xs: 4, md: 6 }, justifyContent: "center", children: testimonials.map((testimonial, index) => (_jsx(Grid, { size: { xs: 12, sm: 6, md: 4 }, children: _jsx(Card, { elevation: 0, sx: {
                                height: '100%',
                                backgroundColor: theme.palette.background.paper,
                                border: `1px solid ${theme.palette.divider}`,
                                borderRadius: { xs: 3, md: 4 },
                                transition: 'box-shadow 0.2s ease-in-out',
                                '&:hover': {
                                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                },
                            }, children: _jsxs(CardContent, { sx: { p: { xs: 5, md: 6 } }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 3, mb: 4 }, children: [_jsx(Avatar, { sx: {
                                                    width: { xs: 40, md: 48 },
                                                    height: { xs: 40, md: 48 },
                                                    bgcolor: getAvatarColor(testimonial.name),
                                                    fontSize: { xs: '14px', md: '16px' },
                                                    fontWeight: 600,
                                                }, children: getInitials(testimonial.name) }), _jsxs(Box, { children: [_jsx(Typography, { variant: "subtitle1", sx: {
                                                            fontWeight: 600,
                                                            fontSize: { xs: '14px', md: '16px' },
                                                            color: theme.palette.text.primary,
                                                            lineHeight: 1.3,
                                                        }, children: testimonial.name }), _jsxs(Typography, { variant: "body2", color: "text.secondary", sx: {
                                                            fontSize: { xs: '12px', md: '13px' },
                                                            lineHeight: 1.3,
                                                        }, children: [testimonial.role, ", ", testimonial.company] })] })] }), _jsx(Rating, { value: testimonial.rating, readOnly: true, size: "small", sx: {
                                            mb: 3,
                                            '& .MuiRating-iconFilled': {
                                                color: modernizeColors.warning.main,
                                            },
                                        } }), _jsxs(Typography, { variant: "body2", color: "text.secondary", sx: {
                                            lineHeight: 1.6,
                                            fontSize: { xs: '13px', md: '14px' },
                                            fontStyle: 'italic',
                                        }, children: ["\"", testimonial.quote, "\""] })] }) }) }, index))) })] }) }));
};
